import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "step-process" }
const _hoisted_2 = { class: "subtitle" }
const _hoisted_3 = { class: "step-box" }
const _hoisted_4 = ["src"]

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'StepProcess',
  props: {
  stepTitle: {
    default: null,
    type: Object
  },
  stepType: {
    default: 'step1',
    type: String
  },
},
  setup(__props) {

const props = __props

const stepData: any = {
  step1: require('@/assets/images/ar-images/xnfz-bottom.png'),
  step2: require('@/assets/images/ar-images/xnfz-bottom2.png')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stepTitle, (item, index) => {
        return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(item), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: stepData[__props.stepType]
      }, null, 8, _hoisted_4)
    ])
  ]))
}
}

})